import { Form } from 'formik';
import { rgba } from 'polished';
import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled, { type DefaultTheme } from 'styled-components';

import { Breakpoint, LanguageSelect, resizedAssetUrl, tokens } from '@treams/treams-ui';

import Logo from '../../../../../../src/packages/kakapo-ui-kit/components/common/Logo';

interface IProps {
	children: ReactNode;
	empty?: boolean;
}

// Inlining this caused issues with ts-styled-plugin (it disallows line breaks, not escaping the template literal)
const backgroundImageFromTheme = (theme: DefaultTheme) =>
	resizedAssetUrl(theme.images.loginBackground, { width: 1920, height: 1080 });

export const Background = styled.div<{ empty?: boolean }>`
	background-image: url('${(props) => backgroundImageFromTheme(props.theme)}');
	background-size: cover;
	background-position: center;
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;

	${(props) =>
		props.empty &&
		`
	@media screen and (max-width: ${Breakpoint.Small}) {
		display: block;
	}`}
`;

export const Element = styled.div<{ empty?: boolean }>`
	${(props) =>
		props.empty
			? `
		padding: 40px;
		max-width: 660px;
	`
			: `
		padding: ${tokens.padding.section}px 40px 40px 40px;
		max-width: 460px;
		flex: 1;
	`}
	background: ${tokens.surface.white};
	border-radius: ${tokens.radius.md}px;
	box-shadow:
		0 2px 4px ${rgba('black', 0.125)},
		0 8px 16px ${rgba('black', 0.05)},
		0 32px 64px ${rgba('black', 0.125)};
	position: relative;
	margin: 20px 0;

	@media screen and (max-width: ${Breakpoint.Small}) {
		padding: 24px 20px 20px 20px;
		margin: 0;
	}
`;

export default function PublicForm({ children, empty }: IProps) {
	return (
		<Background empty={empty}>
			<Element empty={empty}>
				<Form>
					<>
						{!empty && (
							<Flex justifyContent="flex-end" mb={`${tokens.gap.group}px`}>
								<LanguageSelect.Synced small compact />
							</Flex>
						)}

						<Box textAlign="center" style={{ marginBottom: tokens.gap.section }}>
							<Logo to="/" />
						</Box>
					</>
					{children}
				</Form>
			</Element>
		</Background>
	);
}
